// extracted by mini-css-extract-plugin
export var actionPlaceholder = "_bn-3";
export var contentContainer = "_bn-0";
export var editorContainer = "_bn-1";
export var quillInputForm = "_bn-2";
export var zoneDivider = "_bn-4";